import type { NextApiRequest, NextApiResponse } from 'next';
import { withAuth } from '../../../lib/apiAuth';
import { getSupabaseAdminClient } from '../../../lib/supabaseAdmin';

/**
 * S7: Acknowledge/dismiss alerts
 * POST /api/alerts/acknowledge { alertId, action: 'acknowledge' | 'dismiss' }
 */
async function handler(
  req: NextApiRequest,
  res: NextApiResponse,
  user: { id: string; email: string; roles: string[]; primaryRole: string }
) {
  if (req.method !== 'POST') {
    return res.status(405).json({ error: 'Method not allowed' });
  }

  const { alertId, action } = req.body || {};

  if (!alertId || !['acknowledge', 'dismiss'].includes(action)) {
    return res.status(400).json({ error: 'Se requiere alertId y action (acknowledge|dismiss).' });
  }

  try {
    const supabaseAdmin = getSupabaseAdminClient();

    const newStatus = action === 'acknowledge' ? 'sent' : 'failed';

    const { data, error } = await supabaseAdmin
      .from('alert_history')
      .update({
        delivery_status: newStatus,
        trigger_data: undefined,
      })
      .eq('id', alertId)
      .select()
      .single();

    if (error) throw error;

    // Log to audit trail
    await supabaseAdmin.from('auditoria_financiera').insert({
      usuario_id: user.id,
      usuario_nombre: user.email,
      usuario_rol: user.primaryRole,
      accion: `alert_${action}`,
      entidad_tipo: 'alert_history',
      entidad_id: alertId,
      descripcion: `Alerta ${action === 'acknowledge' ? 'reconocida' : 'descartada'} por ${user.email}`,
    });

    return res.status(200).json({ success: true, data });
  } catch (error: any) {
    return res.status(500).json({ error: 'Error al procesar la alerta.' });
  }
}

export default withAuth(handler, ['admin', 'asesor']);
